import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/office-table-store';

const OfficeTableContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default OfficeTableContextWrapper;
